module.exports = __webpack_public_path__ + "ship_holding_yacht.cab8cfc.jpg";